<div class="header">
  <div class="header-content">
    <mat-icon class="header-icon">notifications</mat-icon>
    <div class="header-title">
      {{ 'NAVIGATION.NOTIFICATIONS' | translate }}
    </div>
  </div>
  <mat-icon class="close-icon" (click)="closeDialog()">close</mat-icon>
</div>
<mat-dialog-content>
  <div class="notifications-container" (scroll)="handleScroll($event)">
    <div *ngIf="!data.notificationsRef.isLoading; else notificationsLoading">
      <div *ngIf="data.notificationsRef.list.length > 0; else notificationsEmpty">
        <div
          class="notification-item"
          *ngFor="let notification of data.notificationsRef.list"
          (click)="markAsReadAndNavigate(notification)">
          <mat-icon [class]="getClassForType(notification.pushType)">
            {{ getIconForType(notification.pushType) }}
          </mat-icon>
          <div class="notification-text">
            <div class="notification-message">{{ notification.message }}</div>
            <div class="notification-date" *ngIf="notification.createdAt">
              {{ notification.createdAt | date:'dd/MM/yyyy, HH:mm' }}
            </div>
          </div>
          <mat-icon 
            class="notification-dismiss"
            matTooltip="{{ 'COMMON.CLOSE' | translate }}"
            (click)="markAsReadOnly(notification, $event)">close</mat-icon>
        </div>
      </div>
      <div class="notification-state" *ngIf="data.notificationsRef.isLoadingMore">
        {{ 'COMMON.LOADING' | translate }}
      </div>
    </div>

    <ng-template #notificationsLoading>
      <div class="notification-state">
        {{ 'COMMON.LOADING' | translate }}
      </div>
    </ng-template>

    <ng-template #notificationsEmpty>
      <div class="notification-state" *ngIf="shouldShowEmptyState">
        {{ 'PRODUCTS.DIALOGS.ALERTS-PRODUCTS.ALERTS.NO_ALERTS' | translate }}
      </div>
    </ng-template>
  </div>
</mat-dialog-content>
